import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, Compass, PlayCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

// Every page walkthrough, playable from here — handy when you have already dismissed one.
export const GuideShelf = () => {
  const { lang } = useI18n();
  const [guides, setGuides] = useState([]);
  const [mine, setMine] = useState({ finished: [], reward: null });

  useEffect(() => {
    api.get("/guide", { params: { lang } })
      .then(({ data }) => {
        setGuides(data.guides || []);
        setMine({ finished: data.finished || [], reward: data.reward || null });
      })
      .catch((e) => console.error("could not load the walkthroughs", e));
  }, [lang]);

  if (!guides.length) return null;

  return (
    <div data-testid="guide-shelf">
      <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-ink-soft">
        <Compass className="h-4 w-4 text-brand" /> Show me how a page works
      </p>
      {mine.reward && (
        <p className="mt-2 text-sm text-ink-soft" data-testid="guide-shelf-reward">
          {mine.reward.earned
            ? `Thank you — your free ${mine.reward.days} days of Premium are already on.`
            : mine.reward.left === 0
              ? `Watch one right through and a free ${mine.reward.days} days of Premium are yours.`
              : `Watch all four right through and a free ${mine.reward.days} days of Premium are yours — ${mine.reward.left} to go.`}
        </p>
      )}

      <div className="mt-3 grid gap-3 sm:grid-cols-2">
        {guides.map((one) => {
          const seen = mine.finished.includes(one.name)
            || !!localStorage.getItem(`cml_guide_${one.name}`);
          return (
            <Link
              key={one.name}
              to={`${one.page}?tour=1`}
              data-testid={`guide-shelf-${one.name}`}
              className="group rounded-2xl border border-white/10 bg-panel p-5 transition-colors hover:border-brand/50"
            >
              <p className="flex items-center gap-2 text-sm font-semibold">
                <PlayCircle className="h-4 w-4 text-brand" /> {one.called}
                {seen && <Check className="h-3.5 w-3.5 text-forest" data-testid={`guide-seen-${one.name}`} />}
                <span className="ms-auto text-[11px] font-normal text-ink-soft">
                  {Math.round(one.seconds)}s · {one.stops} stops
                </span>
              </p>
              <p className="mt-1.5 text-sm text-ink-soft" dir="auto">{one.blurb}</p>
              <p className="mt-2 text-[11px] text-brand opacity-0 transition-opacity group-hover:opacity-100">
                {seen ? "Watch it again" : "Watch it"} →
              </p>
            </Link>
          );
        })}
      </div>
    </div>
  );
};
